// extracted by mini-css-extract-plugin
export default {"Container":"ModalGlobal_Container__2pAb+"};